<app-design [hidden]="isAJS" [minimal]="isMinimalRoute">
	<div class="ngx-body-container">
		<router-outlet></router-outlet>
	</div>
</app-design>
<sl-loading></sl-loading>
<linq-sockets-progress class="moveToTop" (processFinish)="processFinish($event)" (processClick)="processClick($event)"></linq-sockets-progress>
